import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import { interpret } from "xstate";
import { Guid } from "guid-typescript";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import ClientDetailsMixin from "./ClientDetailsMixin";
import Loader from "../../../components/widgets/loader.vue";
import ClientModule from "@/store/modules/client.module";
import { askToDiscardChanges, discardUnsavedChanges, hasUnsavedChanges } from "@/utilities/unsavedChanges";
import clientOverviewMachine from "./machines/ClientOverviewMachine";
import ClientProfileTabComponent from "./components/ClientProfileTabComponent.vue";
import ClientContactsTabComponent from "./components/ClientContactsTabComponent.vue";
import ClientTeamsTabComponent from "./components/ClientTeamsTabComponent.vue";
import ClientRisksTabComponent from "./components/ClientRisksTabComponent.vue";
import ClientOpportunitiesTabComponent from "./components/ClientOpportunitiesTabComponent.vue";
/**
 * Client Details Components
 *
 * Owns the single ClientOverviewMachine service; every tab is its own component
 * that receives the current `state` and the `machineService` and sends its own events.
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let ClientDetails = /** @class */ (() => {
    let ClientDetails = class ClientDetails extends Mixins(ClientDetailsMixin) {
        constructor() {
            // DATA
            super(...arguments);
            this.ctaButtons = [{ routeName: "Clients" }];
            this.tabIndex = 0;
            this.machine = clientOverviewMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "PMO",
                },
                {
                    text: "Clients",
                    to: "/clients",
                },
                {
                    text: "Client Details",
                    active: true,
                },
            ];
        }
        send(event) {
            this.machineService.send(event);
        }
        // Top-level tab order: Profile, Contacts, Teams, Risks, Opportunities (Operations hidden - Change 61).
        // Every tab change resets all machine regions, then loads the selected tab's data.
        // That closes any open Edit Client / Add-Edit Contact form, so unsaved edits are confirmed first.
        onTabChange(newTabIndex, prevTabIndex, bvEvent) {
            if (hasUnsavedChanges()) {
                bvEvent.preventDefault();
                askToDiscardChanges().then((discard) => {
                    if (discard) {
                        discardUnsavedChanges();
                        this.tabIndex = newTabIndex;
                    }
                });
                return;
            }
            switch (newTabIndex) {
                case 1:
                    this.send({ type: "CONTACT_LOAD" });
                    break;
                case 2:
                    this.send({ type: "TEAM_LOAD" });
                    break;
                case 3:
                    this.send({ type: "RISK_LOAD" });
                    break;
                case 4:
                    this.send({ type: "OPPORTUNITY_LOAD" });
                    break;
                default:
                    this.send({ type: "TAB_RESET" });
                    break;
            }
        }
        // Computed
        get client() {
            return ClientModule.clientDetailedView;
        }
        get title() {
            if (!this.client || !this.client.name || !this.clientId) {
                return "";
            }
            const loadedId = String(this.client.id).toLowerCase();
            const routeId = this.clientId.toString().toLowerCase();
            return loadedId === routeId ? this.client.name : "";
        }
        // Risks (3) and Opportunities (4) fill the leftover page height and scroll on their own.
        get isInsightTab() {
            return this.tabIndex === 3 || this.tabIndex === 4;
        }
        //Lifecycle
        created() {
            this.clientId = Guid.parse(this.$route.params.clientId);
            this.machineService.machine.context.clientId = this.clientId;
            ClientModule.ClearMediaFileData();
            if (ClientModule.countryLists.length === 0) {
                ClientModule.GetCountryStateLists();
            }
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
            });
        }
    };
    ClientDetails = __decorate([
        Component({
            name: "ClientDetails",
            components: {
                Layout,
                PageHeader,
                Loader,
                ClientProfileTabComponent,
                ClientContactsTabComponent,
                ClientTeamsTabComponent,
                ClientRisksTabComponent,
                ClientOpportunitiesTabComponent,
            },
        })
    ], ClientDetails);
    return ClientDetails;
})();
export default ClientDetails;
